import type { DrugTest } from "@repo/models";
import type { GridList, GridPagination } from "@repo/ui";
import type { AxiosRequestConfig } from "axios";

import { BaseController } from "./baseController";
import { BaseGridApi } from "./baseGridApi";

export interface DrugTestsFilter extends GridPagination {
	startDate?: Date | null;
	endDate?: Date | null;
	brands?: (number | string)[];
	channels?: (number | string)[];
	marketers?: (number | string)[];
	states?: (number | string)[];
	branches?: (number | string)[];
	result?: string;
}

export const controller = "DrugTests";

export default class DrugTestsApi {
	static Get = BaseController.GetFn(controller);
	static Post = BaseController.PostFn(controller);

	/** Loads all drug tests matching filters */
	static getDrugTests(filter: DrugTestsFilter, config?: AxiosRequestConfig) {
		return DrugTestsApi.Get<GridList<DrugTest>>("GetDrugTests", filter, config);
	}

	/** Loads saved grid settings for drug tests */
	static loadGridSettings() {
		return BaseGridApi.loadGridSettings(controller, "DrugTests");
	}

	/** Saves grid settings for drug tests */
	static saveGridSettings(settingsJson: string) {
		return BaseGridApi.saveGridSettings(controller, "DrugTests", settingsJson);
	}

	static downloadBulkUploadTemplate() {
		return DrugTestsApi.Get<Blob>("DownloadBulkUploadTemplate", {}, { responseType: "blob" });
	}

	/** Process bulk import file */
	static processBulkImportFile(data: FormData) {
		return DrugTestsApi.Post<{ importLog: string; errorLog?: string }>("ProcessBulkImportFile", {}, data);
	}

	static getGridColumns() {
		return BaseGridApi.getGridColumns<any>(controller, "DrugTest");
	}
}
